"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanOrganizerData = exports.computeMergedState = exports.getInitialSharedState = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialSharedState = {
  gdprModalShown: false,
  loginModalShown: false,
  followNotificationShown: false
};

var getInitialSharedState = function getInitialSharedState(_ref) {
  var _ref$organizers = _ref.organizers,
      organizers = _ref$organizers === void 0 ? [] : _ref$organizers,
      _ref$organizerData = _ref.organizerData,
      organizerData = _ref$organizerData === void 0 ? {} : _ref$organizerData,
      isAuthenticated = _ref.isAuthenticated,
      userId = _ref.userId,
      isGDPRCountry = _ref.isGDPRCountry;
  return _objectSpread(_objectSpread({}, initialSharedState), {}, {
    organizers: organizers,
    organizerData: organizerData,
    isAuthenticated: isAuthenticated,
    userId: userId,
    isGDPRCountry: isGDPRCountry
  });
};

exports.getInitialSharedState = getInitialSharedState;

var reduceDefaultState = function reduceDefaultState(memo, item) {
  return _objectSpread(_objectSpread({}, memo), {}, _defineProperty({}, item, {
    id: item,
    followedByYou: null
  }));
};

var computeMergedState = function computeMergedState(initialState) {
  var _initialState$organiz = initialState.organizerData,
      organizerData = _initialState$organiz === void 0 ? {} : _initialState$organiz,
      organizers = initialState.organizers;
  var updatedOrganizers = Object.keys(organizerData).length ? _toConsumableArray(new Set([].concat(_toConsumableArray(organizers), _toConsumableArray(Object.keys(organizerData))))) : organizers;
  var defaultOrganizerData = updatedOrganizers.reduce(reduceDefaultState, {});
  return _objectSpread(_objectSpread({}, initialState), {}, {
    organizers: updatedOrganizers,
    organizerData: _objectSpread(_objectSpread({}, defaultOrganizerData), organizerData)
  });
};

exports.computeMergedState = computeMergedState;

var isNotFollowed = function isNotFollowed(_ref2) {
  var followedByYou = _ref2.followedByYou;
  return followedByYou === false;
};

var hasName = function hasName(_ref3) {
  var name = _ref3.name;
  return !!name;
};

var identity = function identity(d) {
  return d;
};

var reduceToObject = function reduceToObject(acc, data) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, data.id, data));
};

var cleanOrganizerData = function cleanOrganizerData(organizers, organizerData, isHiddenWhenFollowed) {
  var filteredOrganizerData = organizers.map(function (orgId) {
    return organizerData[orgId];
  }).filter(isHiddenWhenFollowed ? isNotFollowed : identity).filter(hasName).reduce(reduceToObject, {});
  return {
    organizers: Object.keys(filteredOrganizerData),
    organizerData: filteredOrganizerData
  };
};

exports.cleanOrganizerData = cleanOrganizerData;